import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router, NavigationExtras } from '@angular/router';
import { NotificationsService } from 'angular4-notifications';
import { AuthenticateService } from '../../../common/services/authenticate.service';
import { GlobalFunction } from '../../../common/core/global_function';
import { AppGlobal } from '../../../common/app.global';
import { postLoginRedirect } from '../../../common/core/utils';
import  'rxjs/add/operator/filter';

@Component({
    selector: 'app-root',
    templateUrl: 'from-elearning.component.html',
})

export class FromELearningComponent implements OnInit {
    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private location: Location,
        private notificationService: NotificationsService,
        private authenticateService: AuthenticateService,
        private appGlobal: AppGlobal,
    ) {
    }

    ngOnInit(): void {
        this.activatedRoute.queryParams.filter((queryParams) => {
            return queryParams.username && queryParams.token;
        }).subscribe(queryParams => {
            const clearLoginState = this.authenticateService.isLoggedIn() ?
                this.authenticateService.logout() :
                Promise.resolve();
            clearLoginState.then(() => {
                return this.authenticateService.authenicateFromELearning(
                    queryParams.username,
                    queryParams.token
                );
            }).then((rs) => {
                if (rs.code == 200) {
                    return postLoginRedirect(this.location, this.router, this.appGlobal, this.authenticateService);
                } else {
                    let errorMessage = 'Unknown error';
                    let rsJson = rs.json ? rs.json() : rs;
                    if (rsJson.error) {
                        if (rsJson.error === 'access_denied' && rsJson.error_description === 'The credentials cannot be authenticated.') {
                            errorMessage = 'Password is not correct';
                        } else {
                            errorMessage = rsJson.error_description || rsJson.error || errorMessage;
                        }
                    }
                    this.notificationService.error('Error', errorMessage);
                }
                this.router.navigate(['/']);
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/application/authenticate/from-elearning/from-elearning.component.ts